import { createSelector } from 'reselect';
import { getId } from 'conversations-internal-schema/inbox/operators/inboxGetters';
import { getCurrentInbox } from './getCurrentInbox';
export const getCurrentInboxId = createSelector([getCurrentInbox], getId);